<template>
  <div class="palteform-list" v-infinite-scroll="load">
    <div class="plateform-head">
      <div class="beard-box">
        <Breadcrumbs :breadcrumbs="breadcrumbs"></Breadcrumbs>
        <div class="top-search depart-search" >
          <el-input prefix-icon="icon iconfont iconicon_search1" v-model="form.keyword" size="mini" placeholder="搜索员工名称/工号/手机号/邮箱" clearable @input="debounceMixin(doSearch,300)"></el-input>
        </div>
      </div>
      <div class="psonal">
        <p>
          <span class="title">下级部门</span>
          <span class="not-thing" v-if="!selectItem.children || selectItem.children.length === 0">当前部门不包含下级部门</span>
        </p>
      </div>
      <div class="next-depart">
        <div class="next-depart-item" v-for="item in selectItem.children || []" :key="item.depart_id" @click="selectDepart(item)">
          <p><span>{{item.name}}</span><span>{{item.all_number_of_employees}}人</span></p>
          <i class="icon iconfont iconicon_drop_down_arrow"></i>
        </div>
      </div>
      <div class="psonal">
        <p><span class="title">全部成员</span><span class="count">({{total}})</span></p>
      </div>
      <div class="load-lost" v-loading="loading">
        <TableList :data="dataset" :tip="form.keyword ? '- 当前部门暂无此成员 -':'- 当前部门暂无成员 -'" :loading="loading">
          <template slot="realname" slot-scope="data">
            <span class="tags-tip" @click="findTask(data.row)">
              <Myavatar :class="{'setCellStyle':data.row.manage_employee_permission}" :userName="data.row.realname" width="28px" height="28px" :imgUrl="data.row.user_avatar">{{data.row.realname}}</Myavatar>
              <TableTag v-if="getIsDepartAdmin(data.row)" :type="8" />
              <TableTag v-if="data.row.uid === userInfo.uid" :type="1" />
            </span>
          </template>
        </TableList>
      </div>
    </div>
  </div>
</template>
<script>
import api from '@/services/api/team/team'
import bus from '@/bus'
import TableList from './table.vue'
import { mapActions, mapState, mapMutations, mapGetters } from 'vuex'
import TableTag from '@/components/tableTag'
import Breadcrumbs from './breadcrumbs'
export default {
  props: ['selectItem', 'breadcrumbs', 'getIsDepartAdmin', 'findTask', 'setCellStyle'],
  components: {
    TableList,
    TableTag,
    Breadcrumbs
  },
  data() {
    return {
      dataset: [],
      loading: false,
      total: 0,
      form: {
        page: 0,
        number: 20,
        keyword: '',
        depart_id: '',
        loadig: false,
        finish: false
      }
    }
  },
  watch: {
    selectItem: {
      handler() {
        this.form.keyword = ''
        this.init()
      },
      deep: true
    }
  },
  computed: {
    ...mapState('layout/layout', {
      tableHeight: state => state.tableHeight,
      userInfo: state => state.userInfo
    }),
  },
  created() {
    this.form.depart_id = this.selectItem.depart_id
  },
  mounted() {
    this.load()
  },
  methods: {
    init() {
      this.form.depart_id = this.selectItem.depart_id
      this.form.page = 0
      this.loading = false
      this.finish = false
      this.dataset = []
      this.load()
    },
    doSearch() {
      this.init()
    },
    async load() {
      console.log(this.form.depart_id)
      if (!this.form.depart_id || this.loading || this.finish) return
      this.loading = true
      this.form.page = this.form.page + 1
      let result = await api.addressBookUserIndex(this.form)
      this.total = result.total
      this.dataset.push(...result.data)
      this.loading = false
      if (result.data.length === 0 || result.total === this.dataset.length) {
        this.finish = true
      }
      console.log(result)
    },
    selectDepart(item) {
      bus.$emit('selectDepart', item)
    }
  }
}
</script>
<style lang="scss">
.palteform-list {
  height: 100%;
  overflow-x: hidden;
  padding-bottom: 20px;
  box-sizing: border-box;
  .depart-search{
    width: 360px;
    height: 32px;
    .el-input__inner{
      line-height: 32;
      height: 32px;
      font-size: 12px !important;
    }
    .el-input__prefix{
      i{
        font-size: 14px;
        margin: 0;
      }
    }
     .el-input__icon{
       line-height: 32px;
     }

  }
  .setCellStyle {
    cursor: pointer;
    &:hover {
      .name-txt {
        color: $color-active;
      }
    }
  }
  .next-depart {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 40px;
  }
  .not-thing {
    font-size: 12px;
    color: rgba(32, 32, 32, 0.6);
    height: 32px;
    width: 160px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(32, 32, 32, 0.06);
    position: relative;
    border-radius: 4px;
    margin-left: 15px !important;
    &::before {
      content: '';
      width: 0;
      height: 0;
      border-top: 4px solid transparent;
      border-right: 6px solid rgba(32, 32, 32, 0.06);
      border-bottom: 4px solid transparent;
      position: absolute;
      left: -6px;
      top: 50%;
      transform: translate(0, -50%);
    }
  }
  .next-depart-line {
    border-top: 1px solid rgba(231, 232, 237, 0.6);
    margin-top: 32px;
    margin-bottom: 24px;
  }
  .next-depart-item {
    height: 48px;
    width: 320px;
    border-radius: 4px;
    border: 1px solid rgba(32, 32, 32, 0.16);
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    padding: 0 16px;
    margin-bottom: 8px;
    margin-right: 16px;
    cursor: pointer;
    &:hover {
      background-color: #f7f8f9;
      p {
        span:first-child {
          color: $color-active;
        }
      }
    }
    i {
      font-size: 12px;
      color: rgba(32, 32, 32, 0.24);
    }
    p {
      span:first-child {
        font-size: 14px;
        color: initial;
      }
      span:last-child {
        font-size: 12px;
        color: rgba(32, 32, 32, 0.6);
        margin-left: 16px;
      }
    }
  }
  .load-lost {
    .loading-box {
      text-align: center;
    }
  }
}
</style>
